import client from "../libs/HttpClient";

class NewsLetterMailServices {
  static newslettermailList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/newslettermail?page=${page_no}`, request);
  }
  static deleteNewsLetterMail(params) {
    return client.delete(`delete-newslettermail`, { params });
  }
}
export { NewsLetterMailServices };
